<div class="home-wrap">
  <app-header></app-header>
  <div class="home-section-wrap d-flex justify-content-center">
    <div class="record-section d-flex flex-column justify-content-center">
      <p class="mb-3 start-txt text-center">Start Recording and say the following sentence</p>
      <div class="d-flex align-items-center justify-content-center mb-5">
        <h5 class="sentence">{{sentence.sentence}}</h5>
        <button (click)="randomSentence()" class="btn d-flex align-items-center justify-content-center skip-button">
          <mat-icon class="mr-1">refresh</mat-icon>
          <span class="d-inline-block">Skip</span>
        </button>
      </div>
      <div class="form-wrapper d-flex flex-column justify-content-center">
        <section class="justify-content-center flex-column hurray-sect mb-3" [ngClass]="(uploadCount > 0) ? 'd-flex' : 'd-none'">
          <div class="d-flex justify-content-center mb-1">
            <img src="../../assets/svg/celebration.svg" class="" alt="celebration img">
            <img src="../../assets/svg/celebration.svg" class="" alt="celebration img">
          </div>
          <h5 class="hurray-det text-center mb-0"><span class="hurray-count font-weight-bold">{{uploadCount}}</span> audio uploaded so far</h5>
          <h3 class="text-center">We now have <span class='font-weight-bold'>{{totalRecording && totalRecording}} / 5000 </span>. Thank you!!!</h3>
          <h3 class="text-center">Keep it coming 🕺💃</h3>
        </section>
        <section class="font-weight-bold text-center counter-num mb-5">
          <div *ngIf="counter; else elseBlock"> {{hours}}: {{minutes}}: {{seconds}} </div>
          <ng-template #elseBlock> 00:00:00 </ng-template>
        </section>
        <section class="font-weight-bold text-center counter-num mb-3">
          <img src="../../assets/svg/recording_svg.svg" class="" alt="recording img">
        </section>
        <div class="d-flex justify-content-center">
          <button [disabled]="recording || files.length>0" matTooltip="Record" mat-icon-button (click)="startRecording()">
            <mat-icon>mic</mat-icon>
          </button>
          <button *ngIf="recordPaused" matTooltip="Play" mat-icon-button (click)="pauseRecording()">
            <mat-icon>play_arrow</mat-icon>
          </button>
          <button *ngIf="!recordPaused && recording" matTooltip="Pause" mat-icon-button (click)="pauseRecording()">
            <mat-icon>pause</mat-icon>
          </button>
          <button [disabled]="!recording" matTooltip="Stop" mat-icon-button (click)="stopRecording()">
            <mat-icon>stop</mat-icon>
          </button>
        </div>
        <div *ngFor="let file of files">
          <div class="d-flex justify-content-center align-items-center mt-2">
            <audio controls [src]="file?.url"  type="audio/mpeg" #audio class="d-block mr-3">
              Your browser does not support the audio element.
            </audio>
            <button (click)="clearRecording()"  matTooltip="Delete Recording"  class="d-flex justify-content-center align-items-center delete-icon">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
            <div>
              <p class="mt-2 text-center">{{file?.name}} &nbsp;&nbsp;&nbsp; <span>{{ formatBytes(file?.size)}}</span></p>
              <div class="progress-container" *ngIf="file?.progress > 0">
                <div class="progress" [style.width]="file?.progress + '%'"></div>
              </div>
              <div class="d-flex justify-content-around align-items-center">
                <button mat-raised-button class="d-block btn upload-btn mr-3" (click)="sendFile(file)">Upload</button>
                <a [href]="file?.url" [download]="file.name" class="d-block download-btn">Download</a>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="container">
  <div class="text-center mt-5 sentence-label">
      Start Recording and say the following sentence
  </div>
  <div class="text-center mt-5 sentence">
    {{sentence.sentence}}
        <button mat-icon-button (click)="randomSentence()"><mat-icon>refresh</mat-icon></button>
</div>

  <div class="mt-5">
      <div class="card shadow-sm mx-auto p-3">
          <div class="card-body text-center">
            <div class="timer-counter-label">
              <div *ngIf="counter; else elseBlock"> {{hours}}: {{minutes}}: {{seconds}} </div>
              <ng-template #elseBlock> 00:00:00 </ng-template>
            </div>
            <div class="my-4">
              <img src="../../../assets/images/iconsfolder/podcastIconVoice.svg" width="100">
            </div>
            <div class="m-2">
              <button [disabled]="recording || files.length>0" mat-icon-button (click)="startRecording()">
                <mat-icon>mic</mat-icon>
              </button>
              <button *ngIf="recordPaused" mat-icon-button (click)="pauseRecording()">
                <mat-icon>play_arrow</mat-icon>
              </button>
              <button *ngIf="!recordPaused && recording" mat-icon-button (click)="pauseRecording()">
                <mat-icon>pause</mat-icon>
              </button>
              <button [disabled]="!recording" mat-icon-button (click)="stopRecording()">
                <mat-icon>stop</mat-icon>
              </button>
            </div>
            <div class="my-3"  *ngFor="let file of files">
              <audio controls [src]="file?.url" #audio>
                Your browser does not support the audio element.
              </audio>
              <div>
                <p class="mt-2">{{file?.name}} &nbsp;&nbsp;&nbsp; <span>{{ formatBytes(file?.size)}}</span></p>
                <div class="progress-container" *ngIf="file?.progress > 0">
                  <div class="progress" [style.width]="file?.progress + '%'"></div>
                </div>
                <button mat-raised-button color="primary" (click)="sendFile(file)">Upload</button>
                <a [href]="file?.url" [download]="file.name">Download</a>
              </div>
            </div>
          </div>
      </div>
  </div>
</div> -->
